export const samura = {
    'name': "samura",
    'shortDescription': "Samura Arquitectura es una firma innovadora con sede en [Ciudad], especializada en la creación de espacios arquitectónicos que fusionan funcionalidad, estética y sostenibilidad. \n\n Fundada en el año [Año de fundación] por un equipo de visionarios liderados por [Nombre del fundador], Samura ha establecido su reputación como líder en el diseño arquitectónico, ofreciendo soluciones creativas y eficientes para proyectos residenciales, comerciales e institucionales.",

    'description': ""
}


export const members = [
    
]